import type { SVGProps } from 'react';
const SvgAvito = ({ width = 90, height = 90, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 90 90"
    width={width}
    height={height}
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path fill="#FFF" d="M0 0h90v90H0z" />
      <circle cx={59} cy={59} r={16} fill="#97CF26" />
      <circle cx={29} cy={29} r={13} fill="#0AF" />
      <circle cx={59} cy={29} r={10} fill="#FF6163" />
      <circle cx={28.5} cy={58.5} r={7.5} fill="#A169F7" />
    </g>
  </svg>
);
export default SvgAvito;
